import {instanceToPlain} from 'class-transformer';
import {IsEnum} from 'class-validator';

import {Prettify} from '@ngrx/signals';
import {uuidv4} from '@shared-types';

import {StationStatusType} from '../../cycles';
import {AbstractTriggerEntity, AlertAction, TriggerActionEntity, TriggerEntityClassMetadata, TriggerEventType} from '../index';

export class StationStatusTriggerEntity extends AbstractTriggerEntity {
	static override _uniqueId: string = uuidv4();
	/* ------------------- Action ------------------- */
	action: AlertAction;

	/* -------------------  Value ------------------- */
	public static readonly StationStatusValueType = {
		[StationStatusType.Alert]: 6,
	} as const;
	@IsEnum(StationStatusTriggerEntity.StationStatusValueType, {message: 'trigger.errors.invalidStationStatusValue'}) public value: KeyOrValueOf<
		typeof StationStatusTriggerEntity.StationStatusValueType
	> = StationStatusType.Alert;

	protected constructor(init?: Partial<AbstractTriggerEntity>) {
		super(TriggerEventType.StationStatus, init);
		if (init?.action) this.action = TriggerActionEntity.create<AlertAction>(init?.action?.type, init?.action as AlertAction);
	}

	public static is(entity: AbstractTriggerEntity): entity is StationStatusTriggerEntity {
		return entity.event === TriggerEventType.StationStatus;
	}

	public static create(init: Partial<StationStatusTriggerEntity>): StationStatusTriggerEntity {
		switch (init.value) {
			case StationStatusTriggerEntity.StationStatusValueType.Alert:
				return new UserAlertStationStatusEventTrigger({...init, value: StationStatusTriggerEntity.StationStatusValueType.Alert});
			default:
				throw new Error('Invalid station status value');
		}
	}

	toJSON(): Prettify<AbstractTriggerEntity> {
		return instanceToPlain(this, {}) as StationStatusTriggerEntity;
	}
}

// Station State - User Triggered Alert:
@GroupDecorator('trigger-entity', true)
@ClassMetaData<TriggerEntityClassMetadata>({
	name: 'station-user-alert-trigger',
	type: TriggerEventType.StationStatus,
	label: 'components.trigger-editor.event.station-user-alert.summary',
	summary: 'components.trigger-editor.event.station-user-alert.summary',
	availableActionClasses: [AlertAction],
})
export class UserAlertStationStatusEventTrigger extends StationStatusTriggerEntity {
	static override _uniqueId: string = uuidv4();
	public override readonly value: (typeof StationStatusTriggerEntity.StationStatusValueType)[keyof typeof StationStatusTriggerEntity.StationStatusValueType] =
		StationStatusTriggerEntity.StationStatusValueType[StationStatusType.Alert];

	constructor(init?: Partial<StationStatusTriggerEntity>) {
		super(init);
		if (init?.action) this.action = TriggerActionEntity.create<AlertAction>(init?.action?.type, init?.action as AlertAction);
	}

	override toJSON(): Prettify<UserAlertStationStatusEventTrigger> {
		return instanceToPlain(this, {}) as UserAlertStationStatusEventTrigger;
	}
}
